import React, { useState, useEffect } from "react";
import {
  BaseUrl,
  VoiceDomainName,
  systemTimeZone,
  VoiceDomainNamePure,
} from "../../container/BaseUrl/BaseUrl";
import {
  Button,
  OutlinedInput,
  Pagination,
  Typography,
  InputLabel,
  MenuItem,
  FormControl,
  Select,
  Stack,
  Slide,
  DialogTitle,
  DialogContent,
  DialogActions,
  Dialog,
  Box,
  IconButton,
  styled,
} from "@mui/material";
import { toast } from "react-toastify";
import axios from "axios";
import moment2 from "moment-timezone";
import moment from "moment";
import { connect } from "react-redux";
import { setDialedNumberInc } from "../../redux/actions/actions";
import {
  ArrowCounterClockwise,
  WarningCircle,
  PhoneOutgoing,
  PhoneTransfer,
  ArrowLeft,
} from "@phosphor-icons/react";
import { BiLeftArrow } from "react-icons/bi";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
const mapStateToProps = (state) => {
  return {
    skillset: state.data.skillset,
    showingStatusVoice: state.contactListData.showingStatusVoice,
  };
};

export const FormControls = styled(FormControl)(({ theme }) => ({
  minWidth: "70px",
  width: "3%",
  backgroundColor: "#fff",
  borderRadius: "5px",
  border: "1px solid #fff",
  boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1), 0px 1px 2px rgba(0, 0, 0, 0.06)",
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "#fff",
    },
    "&:hover fieldset": {
      borderColor: "#fff",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#fff",
      boxShadow: "none",
    },
  },
  [theme.breakpoints.down("sm")]: {
    width: "100%",
  },
}));
export const Selects = styled(Select)(() => ({
  fontSize: "12px",
  "& .MuiSelect-select": {
    paddingTop: "4px",
    paddingBottom: "4px",
    paddingRight: "12px",
  },
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: "transparent",
  },
}));
export const MenuItems = styled(MenuItem)(() => ({
  fontSize: "12px",
}));

const MissedCall = (props) => {
  let loggedInAgent = JSON.parse(localStorage.getItem("tokenAgent"));
  let permission = JSON.parse(localStorage.getItem("permission"));
  var someDate = new Date();
  var date = someDate.setDate(someDate.getDate());
  var defaultValue = new Date(date).toISOString().split("T")[0];

  const isToDateValid = () => {
    return new Date(todate) >= new Date(fromdate);
  };

  const [fromdate, setFromdate] = useState();
  const [todate, setTodate] = useState();
  const [showfilter, setshowfilter] = useState(false);

  const [missedCallList, setmissedCallList] = useState([]);

  const [agentlist, setAgentlist] = useState([]);
  const [multiPageVal, setMultiPageVal] = React.useState(10);
  const [page, setPage] = useState(1);
  const [pagination, setPagination] = useState(0);
  const [spinner, setspinner] = useState("");
  const [openDialog, setopenDialog] = useState(false);
  const [selectedAgents, setselectedAgents] = useState("");
  const [count, setcount] = useState(0);
  const [makecalltable, setMakecalltable] = useState(false);

  const [sourceAgents, setsourceAgents] = useState("");
  const [DestinationAgents, setDestinationAgents] = useState("");
  const [totalcalls, settotalcalls] = useState(0);
  const [selectedCalls, setselectedCalls] = useState();
  const [transfererror, setTransfererror] = useState(false);
  const handleChange = (event, value) => {
    setPage(value);
  };

  const handleChangeSetPage = async (event) => {
    setMultiPageVal(event.target.value);
    setPage(1);
  };

  const MissedCallsAPi = () => {
    axios
      .post(
        BaseUrl + "/contact/listCampaignDetails",
        {
          from_date: fromdate,
          to_date: todate,
          agent_id: loggedInAgent.agent_id,
          limit: 10,
          offset: page == 1 ? 0 : (page - 1) * 10,
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        }
      )
      .then((res) => {
        if (res.data.status) {
          setmissedCallList(res.data.data);
          setPagination(res.data.count);
          setTimeout(() => {
            setspinner("");
          }, 1500);
        } else {
          setmissedCallList([]);
          setPagination(0);
          setTimeout(() => {
            setspinner("");
          }, 1500);
        }
      })
      .catch((err) => {
        setTimeout(() => {
          setspinner("");
        }, 1500);
      });
  };
  const MissedCallsAPiSupervisor = () => {
    axios
      .post(
        BaseUrl + "/contact/listCampaignDetailssupervisor",
        {
          from_date: fromdate,
          to_date: todate,
          agent_id: "",
          limit: multiPageVal,
          offset: page == 1 ? 0 : (page - 1) * multiPageVal,
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        }
      )
      .then((res) => {
        if (res.data.status) {
          setmissedCallList(res.data.data);
          setPagination(res.data.count);
          settotalcalls(res.data.count);
          setTimeout(() => {
            setspinner("");
          }, 1500);
        } else {
          setmissedCallList([]);
          setPagination(0);
          setTimeout(() => {
            setspinner("");
          }, 1500);
        }
      })
      .catch((err) => {
        setTimeout(() => {
          setspinner("");
        }, 1500);
      });
  };

  const agentListdropdown = async () => {
    const basedOnRole = JSON.parse(localStorage.getItem("tokenAgent"));
    await axios
      .post(
        BaseUrl + "/users/listagentList",
        {
          user_id: basedOnRole.user_id,
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        }
      )
      .then((res) => {
        if (res.data.status) {
          setAgentlist(res.data.data);
        } else {
          setAgentlist([]);
        }
      })
      .catch((err) => {
        setShow(true);
        setAgentlist([]);
      });
  };

  useEffect(() => {
    if (loggedInAgent.role == "Supervisor") {
      MissedCallsAPiSupervisor();
      agentListdropdown();
    } else {
      MissedCallsAPi();
    }
  }, [page, multiPageVal]);

  const handleCloseDialogBox = () => {
    setopenDialog(false);
  };

  const handleChangeAgent = (event) => {
    setselectedAgents(event.target.value);
  };

  const handleChangeCount = (event) => {
    setselectedCalls(event.target.value);
  };

  const transfer = async (value) => {
    await axios
      .post(
        BaseUrl + "/contact/updatecampaignDetailsagent",
        {
          source_id: sourceAgents,
          destination_id: DestinationAgents,
          count: selectedCalls,
          type: "Abandoned",
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        }
      )
      .then((res) => {
        if (res.data.status) {
          setopenDialog(false);
          MissedCallsAPiSupervisor();
          toast.success("Call Transferred Successfully", {
            position: "top-right",
            autoClose: 500,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: false,
            draggable: false,
            progress: undefined,
            theme: "light",
          });
        }
      })
      .catch((err) => {
        setShow(true);
      });
  };

  const makeCall = (calledNo, value2) => {
    let number =
      localStorage.getItem("TenantId") == "788205e1-6116-4c09-904a-5b641d09de0f"
        ? `${calledNo}`
        : `9${calledNo}`;
    if (props.showingStatusVoice == "Ready") {
      localStorage.setItem("callActivate", "true");
      localStorage.setItem("CallMadeFromDcc", "true");
      let agentLoginTerminalId = localStorage.getItem("agentLoginTerminalId");
      let avcurlid = localStorage.getItem("AvcUrl");
      props.setDialedNumberInc(number);
      localStorage.setItem("ClickeToCallPhoneNum", number);
      localStorage.setItem("dailedNumber", number);

      permission.map((module) => {
        if (module.moduleId === "VOICE") {
          const crmScreen = module.screen.find(
            (item) => item.screenId === "SCREENPOPUP" && item.read && item.write
          );
          if (crmScreen) {
            localStorage.setItem("ClickToCall", "true");
          }
        }
      });

      axios
        .post(
          avcurlid +
            `/voice/terminal/${agentLoginTerminalId}/createContact/sip:${agentLoginTerminalId}@${
              localStorage.getItem("TenantId") ==
              "788205e1-6116-4c09-904a-5b641d09de0f"
                ? VoiceDomainNamePure
                : VoiceDomainName
            }/sip:${number}@${
              localStorage.getItem("TenantId") ==
              "788205e1-6116-4c09-904a-5b641d09de0f"
                ? VoiceDomainNamePure
                : VoiceDomainName
            }`,
          {},
          {
            headers: {
              ssoToken: localStorage.getItem("ssoToken"),
            },
          }
        )
        .then((res) => {
          if (res.data.status == "OK") {
            localStorage.setItem("misserCallClicktoCall", value2);
          } else {
            toast.warn(res.data.status, {
              position: "top-right",
              autoClose: 500,
              hideProgressBar: true,
              closeOnClick: false,
              pauseOnHover: false,
              draggable: false,
              progress: undefined,
              theme: "light",
            });
          }
        })
        .catch((err) => {
          console.log("makeCall", err.code == " ERR_BAD_REQUEST");
          if (err.code == "ERR_BAD_REQUEST") {
            toast.error("Please change status to Ready", {
              position: "top-right",
              autoClose: 500,
              hideProgressBar: true,
              closeOnClick: false,
              pauseOnHover: false,
              draggable: false,
              progress: undefined,
              theme: "light",
            });
          }
        });
    } else {
      toast.error("Please change status to Ready", {
        position: "top-right",
        autoClose: 500,
        hideProgressBar: true,
        closeOnClick: false,
        pauseOnHover: false,
        draggable: false,
        progress: undefined,
        theme: "light",
      });
    }
  };

  const convertDateTime = (date) => {
    return new Date(date).toISOString().replace("T", " ").substring(0, 19);
  };

  const handelmakeCall = () => {
    setMakecalltable((prevState) => !prevState);
  };

  return (
    <>
      <div className="sessiontable" style={{ overflow: "hidden" }}>
        <header className="header_role ">
          <div className="conatiner-fluid">
            <nav
              className="navbar "
              style={{ paddingTop: "0px", paddingBottom: "0px" }}
            >
              <div className="container-fluid p-0">
                <div className="hed_left d-flex">
                  {loggedInAgent.role == "Supervisor" ? (
                    <Typography>MANAGE ABANDONED Calls</Typography>
                  ) : (
                    <Typography>ABANDONED Calls</Typography>
                  )}
                </div>
                <div className="hed_right d-flex">
                  <Stack direction={"row"} spacing={1}>
                    {loggedInAgent.role == "Supervisor" ? (
                      <Button
                        size="small"
                        variant="contained"
                        endIcon={<PhoneTransfer weight="bold" size={18} />}
                        onClick={() => {
                          setopenDialog(true);
                          agentListdropdown();
                        }}
                      >
                        Transfer Calls
                      </Button>
                    ) : (
                      ""
                    )}

                    <Button
                      size="small"
                      variant="contained"
                      endIcon={
                        <ArrowCounterClockwise
                          weight="bold"
                          size={18}
                          style={{ animation: spinner }}
                        />
                      }
                      onClick={() => {
                        if (loggedInAgent.role == "Supervisor") {
                          MissedCallsAPiSupervisor();
                        } else {
                          MissedCallsAPi();
                        }
                        setspinner("rotate 1s infinite");
                      }}
                    >
                      Refresh
                    </Button>
                    <Button
                      size="small"
                      variant="contained"
                      onClick={() => {
                        setshowfilter(true);
                      }}
                    >
                      filter
                    </Button>
                  </Stack>
                </div>
              </div>
            </nav>
          </div>
        </header>

        {loggedInAgent.role == "Supervisor" ? (
          <div className="container-fluid" style={{ paddingLeft: "1px" }}>
            <div className="container-fluid p-2">
              <div className="card fixed-table-card vh-79 ">
                <div className="card-body agentContactbody">
                  <div className="table-responsive vhm-68">
                    <table className="table table-sm  table-hover align-middle table-fixeded">
                      <thead>
                        <tr>
                          <th scope="col">Agent</th>
                          <th scope="col">Phone Number</th>
                          <th scope="col">SkillSet</th>
                          <th scope="col">CreatedDate</th>
                          <th scope="col">OriginatedStamp</th>
                          <th scope="col">Retry Count</th>
                          <th scope="col">Call Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        {missedCallList.length > 0 ? (
                          missedCallList.map((item) => {
                            return (
                              <tr key={item.id}>
                                <td>{item.agent_id.username}</td>
                                <td>{item.Originator}</td>
                                <td>{item.SkillSet}</td>
                                <td>{convertDateTime(item.CreatedDate)}</td>
                                <td>{convertDateTime(item.OriginatedStamp)}</td>
                                <td>{item.callcount ? item.callcount : 0}</td>
                                <td>{item.callstatus}</td>
                                {loggedInAgent.role == "Supervisor" &&
                                loggedInAgent.supervisoragent == true &&
                                makecalltable ? (
                                  <td>
                                    <IconButton
                                      onClick={() => {
                                        makeCall(item.Originator, item.id);
                                      }}
                                    >
                                      <PhoneOutgoing size={22} weight="bold" />
                                    </IconButton>
                                  </td>
                                ) : (
                                  ""
                                )}
                              </tr>
                            );
                          })
                        ) : (
                          <div
                            className="text-muted"
                            style={{
                              flexDirection: "column",
                              marginTop: "20%",
                              display: "flex",
                              position: "absolute",
                              left: "45%",
                              bottom: "40%",
                            }}
                          >
                            <span className="mx-auto">
                              <WarningCircle size={55} />;
                            </span>
                            <span className="mx-auto">
                              <h5
                                className="text-muted mt-2"
                                style={{ fontFamily: "poppins" }}
                              >
                                No Data Found
                              </h5>
                            </span>
                          </div>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
                <div className="card-footer rounded-0 d-flex justify-content-between">
                  <div>
                    {`Showing ${Math.min(
                      (page - 1) * multiPageVal + 1,
                      isNaN(pagination) ? 0 : pagination
                    )} to ${Math.min(
                      page * multiPageVal,
                      isNaN(pagination) ? 0 : pagination
                    )} of ${isNaN(pagination) ? 0 : pagination} entries`}
                  </div>
                  <div className="d-flex">
                    <Typography
                      className="mt-1"
                      sx={{ textTransform: "capitalize", fontSize: "12px" }}
                    >
                      Set page
                    </Typography>
                    <FormControls
                      className="ms-1"
                      size="small"
                      sx={{ textTransform: "capitalize", fontSize: "12px" }}
                    >
                      <Selects
                        labelId="demo-select-small-label"
                        id="demo-select-small"
                        label="multiPageVal"
                        value={multiPageVal}
                        onChange={handleChangeSetPage}
                      >
                        <MenuItems value={10}>10</MenuItems>
                        <MenuItems value={20}>20</MenuItems>
                        <MenuItems value={50}>50</MenuItems>
                        <MenuItems value={100}>100</MenuItems>
                        <MenuItems value={500}>500</MenuItems>
                      </Selects>
                    </FormControls>
                  </div>
                  <Pagination
                    count={Math.ceil(pagination / multiPageVal)}
                    page={page}
                    color="primary"
                    size="small"
                    style={{ float: "right" }}
                    onChange={handleChange}
                  />
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="container-fluid" style={{ paddingLeft: "1px" }}>
            <div className="container-fluid p-2">
              <div className="card fixed-table-card vh-79 ">
                <div className="card-body agentContactbody">
                  <div className="table-responsive vhm-68">
                    <table className="table table-sm  table-hover align-middle table-fixeded">
                      <thead>
                        <tr>
                          <th scope="col">Phone Number</th>
                          <th scope="col">SkillSet</th>
                          <th scope="col">CreatedDate</th>
                          <th scope="col">OriginatedStamp</th>
                          <th scope="col">Retry Count</th>
                          <th scope="col">Call Status</th>
                          <th scope="col">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {missedCallList.length > 0 ? (
                          missedCallList.map((item) => {
                            return (
                              <tr key={item.id}>
                                <td>{item.Originator}</td>
                                <td>{item.SkillSet}</td>
                                <td>{convertDateTime(item.CreatedDate)}</td>
                                <td>{convertDateTime(item.OriginatedStamp)}</td>
                                <td>{item.callcount ? item.callcount : 0}</td>
                                <td>{item.callstatus}</td>
                                <td>
                                  <IconButton
                                    onClick={() => {
                                      makeCall(item.Originator, item.id);
                                    }}
                                  >
                                    <PhoneOutgoing size={22} weight="bold" />
                                  </IconButton>
                                </td>
                              </tr>
                            );
                          })
                        ) : (
                          <div
                            className="text-muted"
                            style={{
                              flexDirection: "column",
                              marginTop: "20%",
                              display: "flex",
                              position: "absolute",
                              left: "45%",
                              bottom: "40%",
                            }}
                          >
                            <span className="mx-auto">
                              <WarningCircle size={55} />
                            </span>
                            <span className="mx-auto">
                              <h5
                                className="text-muted mt-2"
                                style={{ fontFamily: "poppins" }}
                              >
                                No Data Found
                              </h5>
                            </span>
                          </div>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
                <div className="card-footer rounded-0 d-flex justify-content-between">
                  <div>
                    {`Showing ${Math.min(
                      (page - 1) * multiPageVal + 1,
                      isNaN(pagination) ? 0 : pagination
                    )} to ${Math.min(
                      page * multiPageVal,
                      isNaN(pagination) ? 0 : pagination
                    )} of ${isNaN(pagination) ? 0 : pagination} entries`}
                  </div>
                  <div className="d-flex">
                    <Typography
                      className="mt-1"
                      sx={{ textTransform: "capitalize", fontSize: "12px" }}
                    >
                      Set page
                    </Typography>
                    <FormControls
                      className="ms-1"
                      size="small"
                      sx={{ textTransform: "capitalize", fontSize: "12px" }}
                    >
                      <Selects
                        labelId="demo-select-small-label"
                        id="demo-select-small"
                        label="multiPageVal"
                        value={multiPageVal}
                        onChange={handleChangeSetPage}
                      >
                        <MenuItems value={10}>10</MenuItems>
                        <MenuItems value={20}>20</MenuItems>
                        <MenuItems value={50}>50</MenuItems>
                        <MenuItems value={100}>100</MenuItems>
                        <MenuItems value={500}>500</MenuItems>
                      </Selects>
                    </FormControls>
                  </div>
                  <Pagination
                    count={Math.ceil(pagination / multiPageVal)}
                    page={page}
                    color="primary"
                    size="small"
                    style={{ float: "right" }}
                    onChange={handleChange}
                  />
                </div>
              </div>
            </div>
          </div>
        )}

        {showfilter && (
          <nav className="sidebar_filter active-r" style={{ top: "0px" }}>
            <div className="filter col-md-12 shadow p-4 ">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <p className="mb-0">Filters</p>
                <div className="dismiss ">
                  <span
                    id="session_filter_close_btn"
                    className="material-symbols-outlined"
                    onClick={() => {
                      setshowfilter(false);
                    }}
                  >
                    cancel
                  </span>
                </div>
              </div>

              <div className="filter_form">
                <form className=" fillter_form2 " style={{ height: "75vh" }}>
                  <div className="custom_div">
                    <div className="mb-3 d-flex flex-column text-start">
                      <label htmlFor="fromdate" className="form-label">
                        From
                      </label>
                      <input
                        type="date"
                        className="form-control"
                        id=""
                        aria-describedby="date"
                        value={fromdate}
                        onChange={(e) => setFromdate(e.target.value)}
                        max={defaultValue}
                      />
                    </div>
                    <div className="mb-3 d-flex flex-column text-start">
                      <label htmlFor="todate" className="form-label">
                        To
                      </label>
                      <input
                        type="date"
                        className="form-control"
                        id=""
                        aria-describedby="date"
                        value={todate}
                        onChange={(e) => setTodate(e.target.value)}
                        max={defaultValue}
                      />
                      {!isToDateValid() && (
                        <span
                          className="text-danger fw-bold"
                          style={{ fontSize: "10px" }}
                        >
                          To Date cannot be less than From Date*
                        </span>
                      )}
                    </div>
                  </div>
                </form>

                <div className="filter_submit">
                  <div className="d-flex">
                    <div className="col-md-12 ps-2">
                      <button
                        type="button"
                        id="session_filter_Submit"
                        className="btn btn-primary w-100 text-white"
                        onClick={() => {
                          if (isToDateValid()) {
                            if (loggedInAgent.role == "Supervisor") {
                              MissedCallsAPiSupervisor();
                            } else {
                              MissedCallsAPi();
                            }
                            setPage(1);
                            setshowfilter(false);
                          }
                        }}
                      >
                        Submit
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </nav>
        )}
      </div>

      <Dialog
        open={openDialog}
        keepMounted
        onClose={handleCloseDialogBox}
        aria-describedby="alert-dialog-slide-description"
        sx={{
          "& .MuiPaper-root": {
            padding: 1,
            top: -100,
            maxWidth: "max-content",
          },
        }}
      >
        <DialogTitle
          variant="subtitle2"
          sx={{ fontSize: "16px", fontWeight: 600 }}
        >
          <Stack direction={"row"} alignItems={"center"} spacing={1}>
            <Box sx={{ width: "200px" }}>
              <FormControl sx={{ m: 1, width: 200 }} size="small">
                <InputLabel id="demo-multiple-name-label">
                  Source Agent
                </InputLabel>
                <Select
                  labelId="demo-multiple-name-label"
                  id="demo-multiple-name"
                  value={sourceAgents}
                  onChange={(e) => {
                    setsourceAgents(e.target.value);
                  }}
                  input={<OutlinedInput label="Select Agent" />}
                  MenuProps={{
                    style: {
                      top: "0px",
                      maxHeight: "350px",
                    },
                  }}
                >
                  {agentlist.length > 0 ? (
                    agentlist.map((Agent) => (
                      <MenuItem value={Agent.id} key={Agent.id}>
                        {Agent.username}
                      </MenuItem>
                    ))
                  ) : (
                    <MenuItem
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      {"No Data"}
                    </MenuItem>
                  )}
                </Select>
              </FormControl>
            </Box>

            <Box sx={{ width: "210px" }}>
              <FormControl sx={{ m: 1, width: 200 }} size="small">
                <InputLabel id="demo-multiple-name-label">
                  Destination Agent
                </InputLabel>
                <Select
                  labelId="demo-multiple-name-label"
                  id="demo-multiple-name"
                  size="small"
                  value={DestinationAgents}
                  onChange={(e) => {
                    setDestinationAgents(e.target.value);
                  }}
                  input={<OutlinedInput label="Select Agent" />}
                  MenuProps={{
                    style: {
                      top: "0px",
                      maxHeight: "350px",
                    },
                  }}
                >
                  {agentlist.length > 0 ? (
                    agentlist.map((Agent) => (
                      <MenuItem value={Agent.id} key={Agent.id}>
                        {Agent.username}
                      </MenuItem>
                    ))
                  ) : (
                    <MenuItem
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      {"No Data"}
                    </MenuItem>
                  )}
                </Select>
              </FormControl>
            </Box>
            <Box>
              <FormControl sx={{ width: 100 }} size="small">
                <InputLabel id="demo-multiple-name-label">No.</InputLabel>
                <Select
                  labelId="demo-multiple-name-label"
                  id="demo-multiple-name"
                  onChange={handleChangeCount} // Provide a function to handle changes
                  input={<OutlinedInput label="No." />}
                  MenuProps={{
                    style: {
                      top: "0px",
                      maxHeight: "350px",
                    },
                  }}
                  size="small"
                >
                  {Array.from({ length: totalcalls }, (_, index) => (
                    <MenuItem value={index + 1} key={index}>
                      {index + 1}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
          </Stack>
        </DialogTitle>
        <DialogContent></DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            id="upload-primary-btn"
            size="small"
            onClick={transfer}
          >
            SUBMIT
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default connect(mapStateToProps, { setDialedNumberInc })(MissedCall);
